
import styled from 'styled-components';

const layout = {
  PageWrap: styled.div`
    /* responsive container for one pager */
    margin: 0 auto;
    display: table;
    position:relative;
    padding:0;
    width:100%;
    max-width:1240px;
    height: 100%;
    min-height:3600px;
    box-sizing: border-box;
    background: linear-gradient(to bottom right, ${props => props.theme.colors.bg2} 50%, ${props => props.theme.colors.bg} 50%);
  `,
  ContentWrap: styled.div`
    ${props => (props.theme.widthConcept)}
  `,
  Header: styled.header`
    display: inline-block;
    overflow:auto;
    float:right;
    margin: 0 20px 0 10px;
    width: 30%;
    img{
      display:block;
    }
  `,
  TeaserWrap: styled.div`
    display: block;
    position:relative;
    background-image: url(${props => (props.wrapImg)});
    padding-top: 126%;
    margin-top: 130px;
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: 100%;
  `,
  Teaser: styled.div`
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    width:100%;
    height:100%;
    background-image: url(${props => (props.teaserImg)});
    background-position: center bottom 17%;
    background-repeat: no-repeat;
    background-size: 47%;
    @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
        background-position: center bottom 23%;
    }
  `,
  WhiteBar: styled.div`
    margin: 100px auto;
    width: 40%;
    padding-top:5%;
    background-color:#fff;
    @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
      margin: 50px auto;
    }
  `
};
export default layout;
